/**
 * @generated SignedSource<<caff8c654edc24778f6464907fa12d59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminLibraryContentOrderByFieldFilter = "created_at" | "instances" | "updated_at" | "views" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ContentUsageCount = "none" | "one_or_more" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type AdminLibraryContentOrderByInput = {
  direction: OrderDirection;
  field: AdminLibraryContentOrderByFieldFilter;
};
export type AdminContentLibraryListTablePaginationQuery$variables = {
  after?: string | null;
  before?: string | null;
  collectionIds?: ReadonlyArray<string> | null;
  contentLabelIds?: ReadonlyArray<string> | null;
  contentUsageCount?: ContentUsageCount | null;
  excludeTypes?: ReadonlyArray<ContentType> | null;
  first?: number | null;
  id: string;
  isAIGenerated?: boolean | null;
  isSurvey: boolean;
  last?: number | null;
  orderBy?: AdminLibraryContentOrderByInput | null;
  productIds?: ReadonlyArray<string> | null;
  search?: string | null;
  types?: ReadonlyArray<ContentType> | null;
};
export type AdminContentLibraryListTablePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminContentLibraryListTable_PaginationFragment">;
  } | null;
};
export type AdminContentLibraryListTablePaginationQuery = {
  response: AdminContentLibraryListTablePaginationQuery$data;
  variables: AdminContentLibraryListTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collectionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentLabelIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentUsageCount"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeTypes"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAIGenerated"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSurvey"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "types"
},
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v16 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v17 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v18 = {
  "kind": "Variable",
  "name": "collectionIds",
  "variableName": "collectionIds"
},
v19 = {
  "kind": "Variable",
  "name": "contentLabelIds",
  "variableName": "contentLabelIds"
},
v20 = {
  "kind": "Variable",
  "name": "contentUsageCount",
  "variableName": "contentUsageCount"
},
v21 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v22 = {
  "kind": "Variable",
  "name": "isAIGenerated",
  "variableName": "isAIGenerated"
},
v23 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v24 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v25 = {
  "kind": "Variable",
  "name": "productIds",
  "variableName": "productIds"
},
v26 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v27 = {
  "kind": "Variable",
  "name": "types",
  "variableName": "types"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v30 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  {
    "kind": "Variable",
    "name": "excludedTypes",
    "variableName": "excludeTypes"
  },
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminContentLibraryListTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "kind": "Variable",
                "name": "excludeTypes",
                "variableName": "excludeTypes"
              },
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "kind": "Variable",
                "name": "isSurvey",
                "variableName": "isSurvey"
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "AdminContentLibraryListTable_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminContentLibraryListTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v28/*: any*/),
          (v29/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v30/*: any*/),
                "concreteType": "ContentNodeConnection",
                "kind": "LinkedField",
                "name": "adminLibraryContents",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updateDatetime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAiGenerated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeConnection",
                            "kind": "LinkedField",
                            "name": "usages",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "isSurvey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "organizationUsages",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "entities",
                                    "value": [
                                      "organization"
                                    ]
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                  }
                                ],
                                "concreteType": "ContentUsageNodeConnection",
                                "kind": "LinkedField",
                                "name": "usages",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "usages(entities:[\"organization\"],first:1)"
                              }
                            ]
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "creationDatetime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coverVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnailUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showCoverPlayIcon",
                            "storageKey": null
                          },
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "filters": [
                  "search",
                  "contentLabelIds",
                  "collectionIds",
                  "productIds",
                  "types",
                  "excludedTypes",
                  "contentUsageCount",
                  "isAIGenerated",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "AdminContentLibraryListTable__adminLibraryContents",
                "kind": "LinkedHandle",
                "name": "adminLibraryContents"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ad549d45d462470eb5f1c2f1a30ac87",
    "id": null,
    "metadata": {},
    "name": "AdminContentLibraryListTablePaginationQuery",
    "operationKind": "query",
    "text": "query AdminContentLibraryListTablePaginationQuery(\n  $after: String\n  $before: String\n  $collectionIds: [ID!]\n  $contentLabelIds: [ID!]\n  $contentUsageCount: ContentUsageCount\n  $excludeTypes: [ContentType!]\n  $first: Int\n  $isAIGenerated: Boolean\n  $isSurvey: Boolean!\n  $last: Int\n  $orderBy: AdminLibraryContentOrderByInput\n  $productIds: [ID!]\n  $search: String\n  $types: [ContentType!]\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...AdminContentLibraryListTable_PaginationFragment_4zfopr\n    id\n  }\n}\n\nfragment AdminContentLibraryItemUsages_ContentFragment on Content {\n  id\n}\n\nfragment AdminContentLibraryListTableRowFragment_1KMUys on Content {\n  id\n  name\n  type\n  label\n  updateDatetime\n  isAiGenerated\n  usages {\n    totalCount\n  }\n  organizationUsages: usages(entities: [organization], first: 1) @include(if: $isSurvey) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...ContentInstancesTooltipFragment\n  ...ContentThumbnailWithDetails_ContentFragment\n  ...ContentAdminDropdown_ContentFragment\n}\n\nfragment AdminContentLibraryListTable_PaginationFragment_4zfopr on Organization {\n  id\n  adminLibraryContents(first: $first, after: $after, last: $last, before: $before, search: $search, contentLabelIds: $contentLabelIds, collectionIds: $collectionIds, productIds: $productIds, types: $types, excludedTypes: $excludeTypes, contentUsageCount: $contentUsageCount, isAIGenerated: $isAIGenerated, orderBy: $orderBy) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminContentLibraryListTableRowFragment_1KMUys\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment ContentAdminDropdown_ContentFragment on Content {\n  id\n  ...DuplicateContentButton_ContentFragment\n  ...DeleteContentButton_ContentFragment\n}\n\nfragment ContentInstancesTooltipFragment on Content {\n  usages {\n    totalCount\n  }\n  ...AdminContentLibraryItemUsages_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment DeleteContentButton_ContentFragment on Content {\n  id\n  name\n  usages {\n    totalCount\n  }\n  ...ContentInstancesTooltipFragment\n}\n\nfragment DuplicateContentButton_ContentFragment on Content {\n  id\n  name\n  type\n}\n"
  }
};
})();

(node as any).hash = "76cc964dae70fcf4fb0d9441219833c1";

export default node;
